// 隱藏多語言 feature
// 等 5.0 再打開
// 用這個變數 track 相關的 codebase
const showMultilingualFeature = false;

export default showMultilingualFeature;
